module.exports = __webpack_public_path__ + "07c202438ca6d249570552f7311aad68.glb";